import React, { FunctionComponent, ReactNode } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from '../../../../../hooks/useTranslation';
import Typography from '@material-ui/core/Typography';
import colors from '../../../../../themes/main-colors';
import { Divider } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      marginTop: '10px',
      marginBottom: '10px',
    },
    locationHeader: {
      color: colors.darkGray2,
      paddingLeft: '10px',
    },
    locationHeading: {
      color: colors.darkGray2,
      paddingLeft: '10px',
      marginBottom: '-10px',
      marginTop: '-5px',
    },
    locationAddress: {
      marginBottom: '15px',
      paddingLeft: '10px',
      whiteSpace: 'pre-line',
    },
  }),
);

interface Props {
  alternateLoc?: boolean;
  houseNumber?: string | null;
  accountIdentifier?: string | null;
  locationText?: ReactNode | string | null;
  hideLocationHeader?: boolean;
}

const OutageLocation: FunctionComponent<Props> = ({
  alternateLoc,
  houseNumber,
  locationText,
  accountIdentifier,
  hideLocationHeader,
}) => {
  const classes = useStyles();
  const { t, richT } = useTranslation();
  return (
    <div className={classes.root}>
      {alternateLoc ? (
        <>
          {!hideLocationHeader && (
            <Typography
              variant={'subtitle1'}
              className={classes.locationHeading}
              data-testid="outage-alt-location"
            >
              {t('LOCATION')}
            </Typography>
          )}
          <Typography variant={'subtitle1'} className={classes.locationAddress}>
            {locationText && locationText !== ''
              ? locationText
              : richT('OUTAGE_STREET_ADDRESS', {
                  HOUSE_NUMBER: houseNumber ? houseNumber : '-',
                })}
          </Typography>
        </>
      ) : (
        <>
          <Typography
            variant={'subtitle1'}
            className={classes.locationHeader}
            data-testid="outage-users-location"
          >
            {accountIdentifier}
          </Typography>
          <Typography variant={'subtitle2'} className={classes.locationAddress}>
            {houseNumber}
          </Typography>
        </>
      )}
    </div>
  );
};

export default OutageLocation;
